// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__2_Y9w","Label":"BuildControl_Label__1rq33","Less":"BuildControl_Less__1Ukxe","More":"BuildControl_More__3lckx"};